// extracted by mini-css-extract-plugin
export default {"settingsButton":"styles_settingsButton__VjJzh"};